import en from './en.json'
import fr from './fr.json'
import it from './it.json'
import es from './es.json'
import ge from './ge.json'
import cht from './cht.json'
import chs from './chs.json'
import por from './por.json'
import lv from './lv.json'
import sw from './sw.json'
import est from './est.json'
import ar from './ar.json'
import ru from './ru.json'
import tu from './tu.json'
import ro from './ro.json'
import hu from './hu.json'

export const languages = {
    en: en,
    fr: fr,
    it: it,
    es: es,
    ge: ge,
    cht: cht,
    chs: chs,
    por: por,
    lv: lv,
    sw: sw,
    est: est,
    ar: ar,
    ru: ru,
    tu: tu,
    ro: ro,
    hu: hu
}
